<template>
    <page-template page-id="Credentials" ref="super">

        <document-title :title="$tb('pages.loginPass.documentTitle')"></document-title>

        <template v-slot:before v-if="isTitlebarActive">
            <titlebar :text="$tb('pages.loginPass.header', {0: $store.state.appName})"></titlebar>
        </template>

        <div class="ui column">

            <brand-header :text="$t('pages.loginPass.title')"
                          :has-extension="hasHeaderExtension"
                          :has-logo="hasBrandLogo">
            </brand-header>

            <p v-html="$t( 'pages.loginPass.subheader', {0:username})"></p>

            <messages id="Notifications" ref="postman" error-element-id="server-errors" aria-role="none"></messages>

            <label for="username" class="hidden">{{$t('common.label.username')}}</label>
            <input type="text" id="username" name="username" v-model="username" class="hidden">
            <input type="hidden" id="rid" name="rid" v-model="rid">

            <validated-field id="password-errors"
                             :show-errors-on="showErrors" :has-any-errors="$v.password.$invalid"
                             :validation-rules="[{value: $v.password.required, msg: this.$t('common.validation.field.empty')}]">
                <password-input-field id="password" v-model="$v.password.$model"
                                     autocomplete="current-password"
                                     :label="$t('common.label.password')"
                                     :invalid="$v.password.$invalid && showErrors"
                                     :mandatory="true"
                                     aria-error-element-id="password-errors server-errors"
                                     @enter-pressed.prevent="onConfirm"></password-input-field>
            </validated-field>

            <div class="left aligned field" v-if="this.supportAcr('REMEMBER_ME')">
                <div class="ui custom-ui checkbox">
                    <input id="rememberMe" type="checkbox" v-model="rememberMe">
                    <label for="rememberMe">{{$t('common.label.rememberMe')}}</label>
                </div>
            </div>

            <div class="field">
                <button id="confirm" type="submit" class="ui fluid primary button" @click.prevent="onConfirm">
                    {{$t('common.button.continue')}}
                </button>
            </div>
            <div class="field" v-if="showLoginPassBackButton">
                <button id="back" @click="goBack" class="ui fluid basic button">
                    {{$t('common.button.back')}}
                </button>
            </div>

            <h4 class="custom-ui header" v-html="$t('pages.loginPass.resetPass.header')"></h4>

            <p id="reset-pass-description" v-html="$t('pages.loginPass.resetPass.text')"></p>

            <div class="field">
                <button id="resetPassword" @click="initiatePasswordReset" class="ui fluid basic button" type="button" aria-describedby="reset-pass-description">
                    {{ $t('common.button.reset') }}
                </button>
            </div>
        </div>
    </page-template>
</template>

<script>
import PageTemplate from './template/PageTemplate.vue'
import Titlebar from '../components/Titlebar.vue'
import BrandHeader from '../components/BrandHeader.vue'
import PasswordInputField from '../components/LabeledPasswordInputField.vue'
import Messages from '../components/Messages.vue'
import ValidatedField from '../components/ValidatedField.vue'
import { mixin } from '../js/ciam-mixin.js'
import { brand } from '../js/brand.js'
import { required } from 'vuelidate/lib/validators'

export default {
  components: {
    PageTemplate,
    Titlebar,
    BrandHeader,
    Messages,
    ValidatedField,
    PasswordInputField
  },
  mixins: [mixin, brand],
  data: function () {
    return {
      username: sessionStorage.getItem('storedusername') || this.$store.state.username,
      rid: sessionStorage.getItem('storedrid') || this.$store.state.rid,
      password: '',
      operation: 'pwdreset',
      rememberMe: this.$defaults.REMEMBER_ME_SELECTED,
      showErrors: false
    }
  },
  validations () {
    return {
      password: { required }
    }
  },
  methods: {
    onConfirm: function (e) {
      this.$refs.postman.clear()
      this.showErrors = false

      if (!this.isFormValid()) return

      this.$refs.super.startLoading()

      const payload = this.$api.payloads.buildAuthenticationPayload(this.username, this.password, this.rememberMe, this.rid)
      this.$api.login.authenticateWithPassword(payload, this.handleRoutingResponse, this.onFail)
    },
    isFormValid: function () {
      if (!this.$v.$anyDirty || this.$v.$anyError || this.$v.$invalid) {
        const _this = this

        this.focusFirstErrorField(function () {
          _this.showErrors = true
        })

        return false
      }

      return true
    },
    onFail (response) {
      this.onAjaxError(response)
      this.focus()
      this.$refs.super.stopLoading()
    },
    goBack: function () {
      window.history.length > 1 ? window.history.back() : this.$router.push('/')
    },
    initiatePasswordReset: function () {
      this.$refs.super.startLoading()

      this.$api.codes.sendPasswordReset(this.username, this.operation, this.handleRoutingResponse, this.onFail)
    },
    checkHideErrors: function () {
      if (this.$v.$invalid) return
      this.showErrors = false
    },
    focus: function () {
      const el = $('#password')
      if (el) {
        el.focus()
      }
    }

  },
  mounted: function () {
    console.log(`Login with password [username=${this.username}]`)
    this.focus()
    this.$nextTick(() => {
      const el = document.getElementById('resetPassword')
      if (el) {
        const rect = el.getBoundingClientRect()
        const inView = rect.top >= 0 && rect.bottom <= window.innerHeight
        if (!inView) {
          const passwordEl = document.getElementById('password')
          if (passwordEl) {
            passwordEl.scrollIntoView({ behavior: 'auto', block: 'start' })
          }
        }
      }
    })
  },
  watch: {
    $v: {
      handler () {
        this.checkHideErrors()
      },
      deep: true
    },
    password: {
      handler (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.showErrors = false
          $('#grp_password').siblings('.ui.basic.red').remove()
        }
      }
    }
  }
}
</script>
